var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-wrapper"},[(_vm.title)?_c('page-header',{staticClass:"page-header",attrs:{"title":_vm.title}}):_vm._e(),_vm._v(" "),_vm._t("header"),_vm._v(" "),_c('main',{class:_vm.pageContentClass},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }